import BaseSignUpMachineWrapper from 'domains/signup/signupFlow/base';
import { withSignupProvider } from 'domains/signup/signupFlow/context/signupContext';

export default withSignupProvider(BaseSignUpMachineWrapper);
